import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

export const getNotifications = () => {
  return axios.get(`${API_URL}notifications`);
};

// export const registerUser = (formData) => {
//   return axios.post(`${API_URL}admin/register`, formData);
// };

export const loginAdmin = (email, password, recaptchaToken) => {
  return axios.post(`${API_URL}admin/login`, {
    email,
    password,
    recaptchaToken,
  });
};

export const resetPassword = (token, password, confirmPassword, recaptchaToken) => {
  return axios.post(`${API_URL}admin/reset-password`, {
    token,
    password,
    confirmPassword,
    recaptchaToken,
  });
};

export const forgotPassword = (email, recaptchaToken) => {
  return axios.post(`${API_URL}admin/forgot-password`, { email, recaptchaToken });
};

export const changePasswordApi = ({
  currentPassword,
  newPassword,
  confirmPassword,
  token,
}) =>
  axios.post(
    `${API_URL}/admin/change-password`,
    { currentPassword, newPassword, confirmPassword },
    { headers: { Authorization: `Bearer ${token}` } }
  );

export const getAllCustomers = () => {
  const token = localStorage.getItem("adminToken");
  return axios.get(`${API_URL}admin/customers`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getAllInvoices = async () => {
  const token = localStorage.getItem("adminToken");
  return await axios.get(`${API_URL}admin/invoices`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const downloadInvoice = async (invoiceNumber) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  const response = await axios.get(
    `${process.env.REACT_APP_API_URL}invoices/${invoiceNumber}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
    }
  );

  return response.data;
};

export const getTicketDetails = (customerId) => {
  const token = localStorage.getItem("adminToken");
  return axios.get(
    `${API_URL}support-tickets/tickets/customer/${customerId}/`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const sendResponse = (ticketId, customerEmail, response) => {
  const token = localStorage.getItem("adminToken");
  return axios.post(
    `${API_URL}ticket-responses/send-response`,
    { ticketId, customerEmail, response },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
};

export const getAllPurchases = () => {
  const token = localStorage.getItem("adminToken");
  return axios.get(`${API_URL}purchases`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getCustomerPurchases = async (customerId) => {
  const token = localStorage.getItem("adminToken");
  return await axios.get(`${API_URL}purchases/customer/${customerId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getAdminRequests = (token) => {
  return axios.get(`${API_URL}admin/staff-registration-requests`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// Approve Admin Request
export const approveRequest = (adminId, token) => {
  return axios.post(
    `${API_URL}admin/approve`,
    {
      adminId,
      status: "approved",
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
};

// Reject Admin Request
export const rejectRequest = (adminId, token) => {
  return axios.post(
    `${API_URL}admin/reject`,
    {
      adminId,
      status: "rejected",
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
};

export const fetchCustomerDetails = (token) => {
  return axios.get(`${API_URL}customers/details`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const syncCustomerData = (customerId, token) => {
  return axios.get(`${API_URL}admin/sync-customer/${customerId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const fetchAdminProfile = (token) => {
  return axios.get(`${API_URL}admin/profile`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const setAdminPassword = (token, password, confirmPassword) => {
  return axios.post(`${API_URL}admin/set-password`, {
    token,
    password,
    confirmPassword,
  });
};

export const createBooking = (booking) => {
  return axios.post(`${API_URL}bookings`, booking, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getAllBookings = async () => {
  const token = localStorage.getItem("adminToken");
  return axios.get(`${API_URL}bookings`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const createPaymentOrBooking = (paymentData) => {
  const token = localStorage.getItem("adminToken");
  console.log(API_URL);
  return axios.post(`${API_URL}payments`, paymentData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

// Verify Payment
export const verifyPayment = (cartId) => {
  return axios.get(`${API_URL}payments/verify`, {
    params: { cart_id: cartId },
  });
};

export const updateTicketStatus = (ticketId, status) => {
  const token = localStorage.getItem("adminToken");
  return axios.patch(
    `${API_URL}support-tickets/tickets/${ticketId}/status`,
    { status },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
};

export const getCustomerAddresses = (customerId) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  return axios.get(`${API_URL}customer-address/${customerId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const createAddress = (address, customerId) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  return axios.post(`${API_URL}customer-address`, address, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "customer-id": customerId,
    },
  });
};

export const markBookingAsComplete = async (bookingId, isGrip = false) => {
  const token = localStorage.getItem("adminToken");
  const endpoint = isGrip
    ? `${API_URL}bookings/grip/${bookingId}/status`
    : `${API_URL}bookings/${bookingId}/status`;

  return axios.patch(
    endpoint,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const cancelBooking = async (bookingId, isGrip = false) => {
  const token = localStorage.getItem("adminToken");
  const endpoint = isGrip
    ? `${API_URL}bookings/grip/${bookingId}/cancel`
    : `${API_URL}bookings/${bookingId}/cancel`;

  return axios.patch(
    endpoint,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getActiveStringing = async (completed = false) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  return axios.get(`${API_URL}bookings/active-stringing?completed=${completed}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateStringingStatus = async (bookingId, isGrip, status) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  return axios.patch(
    `${API_URL}bookings/stringing-status/${bookingId}`,
    {
      is_grip: isGrip,
      status: status,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
};

export const confirmInStorePayment = async (bookings, recaptchaToken) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  return axios.post(
    `${API_URL}store-payment/confirm-instore-payment`,
    {
      bookings,
      recaptchaToken,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getAllBigCommerceInvoices = async () => {
  const token = localStorage.getItem("adminToken");

  return await axios.get(`${API_URL}bigcommerce-invoices/metadata`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const downloadBigCommerceInvoice = async (filePath) => {
  const token = localStorage.getItem("adminToken");
  const response = await axios.get(
    `${API_URL}bigcommerce-invoices/${filePath}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
    }
  );
  return response.data;
};

export const updateBigCommerceInvoice = async (invoiceId, payload) => {
  const token = localStorage.getItem("adminToken");
  const response = await axios.put(
    `${API_URL}invoices-edit/${invoiceId}`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const getBigCommerceInvoiceById = async (invoiceId) => {
  const token = localStorage.getItem("adminToken");

  const response = await axios.get(`${API_URL}bcinvoices/${invoiceId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const fetchProductOptions = async () => {
  const token = localStorage.getItem("adminToken");
  const response = await axios.get(`${API_URL}bigcommerce/products`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const regenerateAndDownloadInvoice = async (invoiceId, items) => {
  const token = localStorage.getItem("adminToken");
  const res = await axios.put(
    `${API_URL}invoices-edit/invoices/${invoiceId}/download`,
    { items },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
    }
  );
  return res.data;
};

export const sendInvite = (email) => {
  const token = localStorage.getItem("adminToken");
  return axios.post(
    `${API_URL}invite`,
    { email },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const addManualPurchase = (customerId, purchase) => {
  const token = localStorage.getItem("adminToken");
  return axios.post(`${API_URL}manual-purchase/${customerId}`, purchase, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getStorePurchases = (customerId) => {
  const token = localStorage.getItem("adminToken");
  return axios.get(`${API_URL}manual-purchase/${customerId}/store`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateStorePurchase = (customerId, receiptNumber, data) => {
  const token = localStorage.getItem("adminToken");
  return axios.put(
    `${API_URL}manual-purchase/${customerId}/store/${encodeURIComponent(receiptNumber)}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
};

export const completeInStoreBooking = (bookingId, payload, isGrip = false) => {
  const token = localStorage.getItem("adminToken");
  const endpoint = isGrip
    ? `${API_URL}bookings/grip/${bookingId}/complete-instore`
    : `${API_URL}bookings/${bookingId}/complete-instore`;

  return axios.post(endpoint, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const getRacketFreeEligibilityAdmin = async (customerId, rpId) => {
  const token = localStorage.getItem("adminToken");
  if (!customerId || !rpId) throw new Error("customerId and rpId are required");

  const { data } = await axios.get(
    `${API_URL}free-service/eligibility/racket`,
    {
      params: { customerId, rpId },
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    }
  );
  return data;
};

export const inviteStaffApi = ({
  firstName,
  lastName,
  email,
  role,
  location,
  token,
}) => {
  return axios.post(
    `${API_URL}admin/invite`,
    { firstName, lastName, email, role, location },
    { headers: { Authorization: `Bearer ${token}` } }
  );
};

export const listAdminsApi = (token) =>
  axios.get(`${API_URL}admin/users`, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const updateAdminApi = ({ userId, payload, token }) =>
  axios.put(`${API_URL}admin/users/${userId}`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const deleteAdminApi = ({ userId, token }) =>
  axios.delete(`${API_URL}admin/users/${userId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getLiveGrips = async () => {
  const token = localStorage.getItem("adminToken");
  const res = await axios.get(`${API_URL}grips/live`, {
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    params: { _ts: Date.now() },
  });

  if (!res?.data) throw new Error("No data from grips/live");
  return Array.isArray(res.data.data) ? res.data.data : res.data;
};

export const confirmInStorePaymentGripStaff = async (
  bookings,
  recaptchaToken
) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  return axios.post(
    `${API_URL}confirm-instore-payment/grip/staff`,
    {
      bookings,
      recaptchaToken,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const createPaymentOrBookingGripStaff = async (paymentData) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  return axios.post(`${API_URL}grip-staff-payments`, paymentData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const verifyGripPaymentStaff = async (cartId) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  return axios.get(`${API_URL}grip-staff-payments/verify`, {
    params: { cart_id: cartId },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const listInventory = async () => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  return axios.get(`${API_URL}stringer/inventory`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    timeout: 30000,
  });
};

export const getInventoryItem = async (stringId) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  return axios.get(`${API_URL}stringer/inventory/${stringId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    timeout: 30000,
  });
};

export const updateStock = async (stringId, remainingQuantity, location) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  return axios.put(
    `${API_URL}stringer/inventory/${stringId}/update-stock`,
    {
      string_id: stringId,
      remaining_quantity: remainingQuantity,
      location: location,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      timeout: 30000,
    }
  );
};

export const updateStringName = async (stringId, stringName, brand, imageUrl) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  return axios.put(
    `${API_URL}stringer/inventory/${stringId}/update-name`,
    {
      string_id: stringId,
      string_name: stringName,
      brand: brand,
      image_url: imageUrl,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      timeout: 30000,
    }
  );
};

export const updateCost = async (stringId, costPerUnit) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  return axios.put(
    `${API_URL}stringer/inventory/${stringId}/update-cost`,
    {
      string_id: stringId,
      cost_per_unit: costPerUnit,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      timeout: 30000,
    }
  );
};

export const updateRemaining = async (stringId, quantity) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  return axios.post(
    `${API_URL}stringer/inventory/${stringId}/update-remaining`,
    {
      string_id: stringId,
      quantity: quantity,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      timeout: 30000,
    }
  );
};

export const recordService = async (serviceData) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  return axios.post(`${API_URL}stringer/services`, serviceData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    timeout: 30000,
  });
};

// Helper: normalize display names to backend location keys
export const listServices = async (filters = {}) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  // clone filters so we don't mutate caller's object
  const params = { ...filters };

  // Keep location as-is (will be exact store name: "Jumeirah Store", "Marina Store", "Dubai Hills Store")
  console.log("API - Sending params with location:", params);

  return axios.get(`${API_URL}stringer/services`, {
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    timeout: 30000,
  });
};

export const getService = async (serviceId) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  return axios.get(`${API_URL}stringer/services/${serviceId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    timeout: 30000,
  });
};

export const updateService = async (serviceId, updateData) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  return axios.put(`${API_URL}stringer/services/${serviceId}`, updateData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    timeout: 30000,
  });
};

export const deleteService = async (serviceId) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  return axios.delete(`${API_URL}stringer/services/${serviceId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    timeout: 30000,
  });
};

export const requestServiceCorrection = async (serviceId, reason) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  return axios.post(
    `${API_URL}stringer/services/${serviceId}/request-correction`,
    { reason },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      timeout: 30000,
    }
  );
};

export const editServiceBySuperadmin = async (serviceId, updateData) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  return axios.put(
    `${API_URL}stringer/services/${serviceId}/edit`,
    updateData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      timeout: 30000,
    }
  );
};

export const getStringerStats = async (
  startDate = null,
  endDate = null,
  stringerId = null
) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  const params = {};
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;
  if (stringerId) params.stringer_id = stringerId;

  return axios.get(`${API_URL}stringer/stats`, {
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    timeout: 30000,
  });
};

export const exportServicesToExcel = async (params = {}) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  const response = await axios.get(`${API_URL}stringer/services/export`, {
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: "blob",
    timeout: 30000,
  });

  return response.data;
};

export const addString = async ({
  string_name,
  brand,
  cost_per_unit,
  stock,
  image_url,
}) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");
  return await axios.post(
    `${API_URL}stringer/inventory`,
    { string_name, brand, cost_per_unit, stock, image_url },
    {
      headers: { Authorization: `Bearer ${token}` },
      timeout: 30000,
    }
  );
};

export const deleteString = async (stringId) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");
  return await axios.delete(
    `${API_URL}stringer/inventory/${stringId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      timeout: 30000,
    }
  );
};

// ----- String Inventory Endpoints -----
export const getAllStringsFromInventory = async () => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");
  const response = await axios.get(`${API_URL}string-inventory`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const getStringById = async (stringId) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");
  const response = await axios.get(`${API_URL}string-inventory/${stringId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const getAllFreeServiceClaims = async (customerId) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  const response = await axios.get(`${API_URL}free-service-management/claims`, {
    headers: { Authorization: `Bearer ${token}` },
    params: customerId ? { customerId } : undefined,
  });

  return response.data;
};

export const getFreeServiceClaimById = async (claimId) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  const response = await axios.get(
    `${API_URL}free-service-management/claims/${claimId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  return response.data;
};

export const updateFreeServiceClaim = async (claimId, data) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  const response = await axios.put(
    `${API_URL}free-service-management/claims/${claimId}`,
    data,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  return response.data;
};

export const deleteFreeServiceClaim = async (claimId) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  const response = await axios.delete(
    `${API_URL}free-service-management/claims/${claimId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  return response.data;
};

export const checkStringStockAtLocation = async (stringId, location) => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");

  const response = await axios.get(
    `${API_URL}string-inventory/${stringId}/stock/${location}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  return response.data;
};

export const getActiveDiscountApi = () => {
  return axios.get(`${API_URL}discounts/active`);
};

export const getDiscountsApi = (token) => {
  return axios.get(`${API_URL}discounts`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const createDiscountApi = (payload, token) => {
  return axios.post(`${API_URL}discounts`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const updateDiscountApi = (id, payload, token) => {
  return axios.put(`${API_URL}discounts/${id}`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const deleteDiscountApi = (id, token) => {
  return axios.delete(`${API_URL}discounts/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getCompletedBookingsReceipts = async () => {
  const token = localStorage.getItem("adminToken");
  if (!token) throw new Error("Admin token not found");
  const response = await axios.get(`${API_URL}admin/bookings-receipts`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

// Express Booking Settings
export const getExpressSettingsApi = () => {
  return axios.get(`${API_URL}express-settings`);
};

export const updateExpressSettingsApi = (settingsData, token) => {
  return axios.put(`${API_URL}express-settings`, settingsData, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
